import { useContent } from "@/i18n";

export const TrustStrip = () => {
  const { t } = useContent();
  const items = [...t.trust.items, ...t.trust.items];
  return (
    <section aria-label={t.trust.label} data-testid="trust-strip" className="relative border-y border-gold/20 bg-navy-800">
      <div className="mx-auto flex max-w-[1440px] items-stretch">
        <div className="hidden shrink-0 items-center border-r border-gold/20 px-8 font-mono text-[10px] uppercase tracking-[0.3em] text-gold md:flex">
          {t.trust.label}
        </div>
        <div className="marquee flex-1 overflow-hidden py-6" aria-hidden="true">
          <div className="marquee-track flex w-max items-center gap-12">
            {items.map((item, i) => (
              <span key={`${item}-${i}`} className="flex items-center gap-12 whitespace-nowrap font-serif text-xl text-paper/85 sm:text-2xl">
                {item}
                <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold" />
              </span>
            ))}
          </div>
        </div>
      </div>
      <ul className="sr-only">
        {t.trust.items.map((i) => (
          <li key={i}>{i}</li>
        ))}
      </ul>
    </section>
  );
};
